import { MonitoringPackageAddressEntity } from '@/features/trackOrder/domain/entities/packageEntites/MonitoringPackageAddressEntity'
import { mapEntityProperties } from '@/utils/mapEntityProperties'

export class MonitoringPackageAddressModel extends MonitoringPackageAddressEntity {
  constructor(dataDto: MonitoringPackageAddressEntity) {
    super()
    mapEntityProperties<MonitoringPackageAddressModel>(this, dataDto)
  }
}
